import classNames from 'classnames';
import { IconPlus } from 'featherico';
import type { Plan } from '../types';
import styles from './styles.m.less';

export function CardPlan({ plan, className }: { plan: Plan; className: string }) {
    return (
        <div className={classNames(styles.planContainer, className)}>
            <h1>{plan.title}</h1>
            <p>{plan.description}</p>
            <div className={styles.priceContainer}>
                <p className={styles.priceDescription}>From</p>
                <p className={styles.price}>${plan.price}</p>
                <div className={styles.priceDescription}>
                    <p>/ per user</p>
                    <p>/ per month</p>
                </div>
            </div>
            <p>KEY FEATURES:</p>

            <p>{plan.featureTitle && plan.featureTitle}</p>

            <div className={styles.features}>
                {plan.features.map((featureText, index) => (
                    <div key={index} className={styles.iconFeature}>
                        <IconPlus />
                        {featureText}
                    </div>
                ))}
            </div>
        </div>
    );
}
